import { sendEvent, sendError } from 'shared/bi/bi-facade';
import { getBiDefaultParams } from 'shared/bi/bi-with-state-defaults';

export function sendBiEvent(name, eventParams) {
  return function (dispatch, getState) {
    const state = getState();
    const defaultBiParams = getBiDefaultParams(state);
    const params = { ...defaultBiParams, ...eventParams };
    return sendEvent(name, params);
  };
}

export function sendBiError(name, eventParams) {
  return function (dispatch, getState) {
    const state = getState();
    const defaultBiParams = getBiDefaultParams(state);
    const params = { ...defaultBiParams, ...eventParams };
    return sendError(name, params);
  };
}



// WEBPACK FOOTER //
// ./src/shared/redux/client/actions/bi.js